<template>
  <div>
    <div class="weui-cells weui-cells_checkbox">
      <div class="weui-cell weui-check__label" :class="[point ? 'weui-cell_access' : '', themeName]">
        <div class="weui-cell__hd" @click.passive="likeLabel('head')">
          <slot name="header"></slot>
        </div>
        <div class="text-elps ds-flex align-center weui-cell__bd" @click.passive="likeLabel('body')">
          <slot name="body"></slot>
        </div>
        <div class="weui-cell__ft" @click.passive="likeLabel('foot')">
          <label>
            <input type="checkbox"
                   class="weui-check"
                   disabled="disabled"
                   v-model="tempValue">
            <i :class="[tempValue ? 'text-color orange s-icon-check-circle':'no-check']"></i>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import './index.scss';
</style>
<script>
  export default {
    name: 'c-cell-checkbox',
    props: {
      title: {
        type: String,
        default: ''
      },
      value: {
        type: Boolean,
        default: false
      },
      point: {
        type: Boolean,
        default: true
      },
      themeName: {
        type: String,
        default: ''
      },
      labelType: {
        type: Array,
        default () {
          return ['head', 'body', 'foot'] // [head,body,all] 配置点击区域
        }
      }
    },
    data () {
      return {}
    },
    components: {},
    created () {
    },
    mounted () {
    },
    beforeDestroy () {
    },
    methods: {
      likeLabel (target) {
        // 判断点击区域
        if (!this.labelType.includes(target)) return
        this.tempValue = !this.tempValue
      }
    },
    computed: {
      // value值穿透
      tempValue: {
        set (value) {
          this.$emit('input', value)
          this.$emit('change', value)
        },
        get () {
          return this.value
        }
      }
    },
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?1bb31ce8